export default "__VITE_ASSET__BxzbXJKR__"